export const GET_STATE = "v1/locations/states";
export const GET_CITIES = (STATE_CODE: string) =>
  `v1/locations/cities/by-state-code/${STATE_CODE}`;
